import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from 'vue';
import {useRoute} from 'vue-router';
import {upload} from '@/libs/upload';
import {Toast} from 'vant';
import {purchasesReport, getReportType} from '@/api/miscellaneous';
import router from '@/router';

export default /*#__PURE__*/_defineComponent({
  __name: 'Report',
  setup(__props, { expose }) {
  expose();

const reportType = ref<any>([]);
const imgList = ref<any[]>([]);
const {query} = useRoute();

const reportData = ref<any>({
    supply: true,
    single: false,
    reportTerm: '',
    contents: '',
    photos: [],
});

onMounted(() => {
    reportData.value[`purchaseId`] = query.id || '';
    getReportType().then(res => {
        reportType.value = res;
    });
});

const afterRead = (data: any) => {
    if (!Array.isArray(data)) data = [data];
    let imgUploads = Promise.all(data.map((el: any) => upload({type: 'quotation', obj: el})));
    let uploading = Toast.loading({
        message: '图片上传中...',
        duration: 0,
    });
    imgUploads.then(res => {
        let photos = res.map(el => el.url);
        imgList.value = [...imgList.value, ...res];
        // @ts-ignore
        reportData.value.photos = [...reportData.value.photos, ...photos];
        uploading.clear();
    });
};
const toKefu = () => {
    window.location.href = 'https://work.weixin.qq.com/kfid/kfcdd1c5b9f6d099505';
};
const closeImg = (idx: number) => {
    imgList.value.splice(idx, 1);
    reportData.value.photos.splice(idx, 1);
};
const submit = () => {
    purchasesReport(reportData.value).then(res => {
        Toast.success('举报成功');
        setTimeout(() => {
            router.back();
        }, 2000);
    });
};

const __returned__ = { reportType, imgList, query, reportData, afterRead, toKefu, closeImg, submit, onMounted, ref, useRoute, upload, Toast, purchasesReport, getReportType, router }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})